const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Fav_icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.041 0.183881L13.7776 8.91825C13.5938 9.19407 13.226 9.19407 12.9502 8.91825L8.07732 3.95345C7.70955 3.58569 7.98538 3.03404 8.44508 3.03404H10.2839C10.4678 3.03404 10.5597 3.12598 10.6517 3.21792L12.7663 5.4245C13.0421 5.70032 13.4099 5.60838 13.5938 5.4245L14.789 3.67763C14.9729 3.49375 14.9729 3.12598 14.789 2.9421L12.0308 0.183881C11.9388 0.0919407 11.7549 0 11.5711 0H0.538182C0.078479 0 -0.197343 0.551644 0.17042 0.919407L13.1341 14.0669C13.3179 14.3427 13.7776 14.2508 13.9615 14.0669L22.9717 3.21792C23.0636 3.12598 23.2475 3.03404 23.4314 3.03404H25.1783C25.638 3.03404 25.9138 3.58569 25.638 3.95345L12.3066 20.0431C12.2146 20.135 12.2146 20.227 12.2146 20.4108V23.6288V26.9386C12.2146 27.1225 12.3066 27.2144 12.3985 27.3064L14.3293 29.3291C14.697 29.6968 15.2487 29.421 15.2487 28.9613V23.6288V21.4222C15.2487 21.3302 15.2487 21.1464 15.3406 21.0544L31.89 0.919407C32.1658 0.551644 31.89 0 31.4303 0H21.4087C21.3168 0 21.1329 0.0919407 21.041 0.183881Z",
    style: {
      paintOrder: "fill",
      stroke: "rgb(81, 72, 234)",
      fill: "rgb(254, 254, 254)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.915 23.5368V28.7774C17.915 29.2371 18.4667 29.5129 18.8344 29.1452L20.7652 27.2144C20.8571 27.1225 20.9491 26.9386 20.9491 26.8466V23.4448V19.8591C20.9491 19.3075 20.3055 19.1236 19.9377 19.4914L18.007 22.0657C17.915 22.1577 17.915 22.2496 17.915 22.4335V23.5368Z",
    style: {
      stroke: "rgb(81, 72, 234)",
      fill: "rgb(255, 255, 255)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/whiteLogo.5c7f13b87f11ee0d06fa6307d1e391b4.svg";
export { ForwardRef as ReactComponent };